/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as s from "react";
import { classNames as r } from "@progress/kendo-react-common";
import n from "./Action.mjs";
import { SelectableItemsContainer as i } from "./base/SelectableItemsContainer.mjs";
class l extends i {
  constructor(e) {
    super(e);
  }
  render() {
    const e = this.props.group.actions ? this.props.group.actions.length - 1 : 0;
    return /* @__PURE__ */ s.createElement("div", { className: this.getClassNames(), onClick: this.onRequestContainerSelection, onKeyDown: this.onKeyDown }, this.props.group.actions && this.props.group.actions.map((o, t) => /* @__PURE__ */ s.createElement(
      n,
      {
        item: o,
        onActionExecute: this.props.onActionExecute,
        selected: t === this.state.selectedItemIndex,
        isFirstItemInGroup: t === 0,
        isLastItemInGroup: t === e,
        key: t
      }
    )));
  }
  getClassNames() {
    return r("k-quick-replies");
  }
}
export {
  l as default
};
